// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import * as ActiveStorage from "@rails/activestorage";
ActiveStorage.start();
import "trix"
import "@rails/actiontext"
import "flowbite/dist/flowbite.turbo.js";
import 'flowbite-datepicker';
import "./controllers";
import './streams';